import type { AuctionCar } from '@autobid/ui/types/Car'

export function getMinimalInputPrice(car: AuctionCar, bidStep: number) {
  return car.price.current ? car.price.current + bidStep : car.price.minimal
}
